import {AfterViewInit, Component, Inject, QueryList, ViewChildren} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {MatExpansionPanel} from '@angular/material/expansion';

@Component({
    selector: 'app-feedback-questionnaire-full-description',
    templateUrl: './feedback-questionnaire-full-description.html',
    styleUrls: ['./feedback-questionnaire-full-description.scss']
})
export class FeedbackQuestionnaireFullDescriptionComponent implements AfterViewInit{
    @ViewChildren(MatExpansionPanel) panels!: QueryList<MatExpansionPanel>;

    expand: boolean = false;
    dataReady: boolean = false;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<FeedbackQuestionnaireFullDescriptionComponent>) {
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.dataReady = true;
            let competenceCounter = 0;
            let behaviourCounter = 0;
            this.data.areas.forEach(area => {
                area.competences.forEach(competence => {
                    competenceCounter += 1;
                    competence.counter = competenceCounter;
                    competence.behaviours.forEach(behaviour => {
                        behaviourCounter += 1;
                        behaviour.counter = behaviourCounter;
                    })
                })
            })
        });
    }

    expandAll(): void {
        this.panels.forEach(panel => panel.open());
        this.expand = true;
    }

    collapseAll(): void {
        this.panels.forEach(panel => panel.close());
        this.expand = false;
    }
}